// Module
var code = "<li class=bigSelectOption data-cid=\"<%= value %>\"><%= text %></li> ";
// Exports
module.exports = code;